
  
  export default {
      data() {
          return {
              selectedLocation: null,
              locations: [
                  { id: 1, name: 'Location 1', lat: -4.337913, lng: 122.1973081 },
                  { id: 2, name: 'Location 2', lat: -4.2027915	, lng: 122.4467238	 },
                  { id: 3, name: 'Location 3', lat: -4.428241619393043, lng: 122.44844225767083 },
              ],
  
              jmlInvestasi : '',
              totalInvestasi : '',
              totalTKI : '',
              list_peta : [],
  
              totalSkalaBesar : '',
              totalSkalaKecil : '',
              totalSkalaMenengah : '',
              totalSkalaMikro : '',
  
              kelompok_kecamatan: '',
  
              clusterOptions: {
                gridSize: 30,
                maxZoom: 15,
              },
              point: '',
              infoWindowPos: '', // Infowindow position
              infoOptions: {
                content: '',
                //optional: offset infowindow so it visually sits nicely on top of our marker
                pixelOffset: {
                  width: 0,
                  height: -35
                }
              },
              infoWinOpen: false,
              currentMidx: null,
  
  
  
              mdl_lihat: false,
  
              form : {
                id : '',
                jns_perusahaan : '',
                alamat : '',
                alamat : '',
                alamat : '',
                alamat : '',
                alamat : '',
              },
          }
      },
      methods: {
          posisinya: function(latitude, longitude) {
            var tes= { lat:parseFloat(latitude), lng:parseFloat(longitude)}
          //   console.log(tes);
            return tes;
              
          },
          // onMarkerClick(marker, idx) {
          //     console.log(marker);
          //     this.infoWindowPos = { lat: parseFloat(marker.lat), lng: parseFloat(marker.lng) };
          //     this.infoOptions.content = `latitude : ${marker.lat}, longitude: ${marker.lng}  <br/><p><a href="https://www.google.com/maps/place/${marker.lat},${marker.lng}/@${marker.lat},${marker.lng}z/data=!3m1!4b1" target="_blank">Cek Lokasi!</a> </p>`;
          //     console.log(this.infoOptions.content);
          //     if (this.currentMidx == idx) {
          //       this.infoWinOpen = !this.infoWinOpen;
          //     }
          //     else {
          //       this.infoWinOpen = true;
          //       this.currentMidx = idx;
          //     }
          // },
          selectData : function(location){
              this.form.id = location.id;
              this.form.nm_perusahaan = location.nm_perusahaan;
              this.form.status_penanaman_modal = location.status_penanaman_modal;
              this.form.jns_perusahaan = location.jns_perusahaan;
              this.form.nama_proyek = location.nama_proyek;
              this.form.risiko_proyek = location.risiko_proyek;
              this.form.skala_usaha = location.skala_usaha;
              this.form.kab_kota_usaha = location.kab_kota_usaha;
              this.form.alamat = location.alamat;
              this.form.kecamatan_id = location.kecamatan_id;
              this.form.des_kel_id = location.des_kel_id;
              this.form.judul_kbli = location.judul_kbli;
              this.form.luas_tanah = location.luas_tanah;
              this.form.jml_investasi = location.jml_investasi;
              this.form.lat = location.lat;
              this.form.lng = location.lng;
              this.form.keterangan = location.keterangan;
              this.form.satuan_tanah = location.satuan_tanah;
              this.form.status = location.status;
              this.form.tki = location.tki;
  
              this.form.nama_kecamatan = location.nama_kecamatan;
              this.form.nama_des_kel = location.nama_des_kel;
          },
          
          getView: function() {
              fetch(this.$store.state.url.URL_POTENSI + "view", {
                  method: "POST",
                  headers: {
                      "content-type": "application/json"
                  },
              })
                  .then(res => res.json())
                  .then(res_data => {
                      this.list_peta = res_data;
                     
                      // console.log(res_data);
              });
          },
          getInvestasi : function() { 
            fetch(this.$store.state.url.URL_DASHBOARD + "jmlInvestasi", {
                  method: "POST",
                  headers: {
                      "content-type": "application/json"
                  }, 
              })
              .then(res => res.json())
              .then(res_data => {
                  this.jmlInvestasi = res_data.total
                  // console.log(res_data);
              }); 
          },
          getTotalInvestasi: function() {
            fetch(this.$store.state.url.URL_DASHBOARD + "totalInvestasi", {
                  method: "POST",
                  headers: {
                      "content-type": "application/json"
                  },
              })
                  .then(res => res.json())
                  .then(res_data => {
                      this.totalInvestasi = res_data.totalInvestasi;
                      // console.log(res_data);
              });
          },
          getTotalTKI: function() {
            fetch(this.$store.state.url.URL_DASHBOARD + "totalTKI", {
                  method: "POST",
                  headers: {
                      "content-type": "application/json"
                  },
              })
                  .then(res => res.json())
                  .then(res_data => {
                      this.totalTKI = res_data.totalTKI;
                      // console.log(res_data);
              });
          },
          getSkalaBesar: function() {
            fetch(this.$store.state.url.URL_DASHBOARD + "jmlSkalaBesar", {
                  method: "POST",
                  headers: {
                      "content-type": "application/json"
                  },
              })
                  .then(res => res.json())
                  .then(res_data => {
                      this.totalSkalaBesar = res_data.total;
                      // console.log(res_data);
              });
          },
          getSkalaKecil: function() {
            fetch(this.$store.state.url.URL_DASHBOARD + "jmlSkalaKecil", {
                  method: "POST",
                  headers: {
                      "content-type": "application/json"
                  },
              })
                  .then(res => res.json())
                  .then(res_data => {
                      this.totalSkalaKecil = res_data.total;
                      // console.log(res_data);
              });
          },
          getSkalaMenengah: function() {
            fetch(this.$store.state.url.URL_DASHBOARD + "jmlSkalaMenengah", {
                  method: "POST",
                  headers: {
                      "content-type": "application/json"
                  },
              })
                  .then(res => res.json())
                  .then(res_data => {
                      this.totalSkalaMenengah = res_data.total;
                      // console.log(res_data);
              });
          },
          getSkalaMikro: function() {
            fetch(this.$store.state.url.URL_DASHBOARD + "jmlSkalaMikro", {
                  method: "POST",
                  headers: {
                      "content-type": "application/json"
                  },
              })
                  .then(res => res.json())
                  .then(res_data => {
                      this.totalSkalaMikro = res_data.total;
                      // console.log(res_data);
              });
          },
  
          getKecamatan: function() {
              fetch(this.$store.state.url.URL_DASHBOARD + "viewKecamatan", {
                  method: "POST",
                  headers: {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                  },
                  body: JSON.stringify({
                      kecamatan : this.pilih_kecamatan,
                  })
              }).then(res => res.json())
                  .then(res_data => {
                  this.kelompok_kecamatan = res_data.data;
  
                  var kelompok_kecamatan = [];
                  var hasil = this.kelompok_kecamatan;
                  for(var i in hasil) {
                      kelompok_kecamatan.push([
                          hasil[i].nama_kecamatan,
                          hasil[i].jml
                      ])
                  }
                  // console.log(res_data);
  
                  this.grafikKecamatan(kelompok_kecamatan);
              });
          },
  
          grafikKecamatan(kelompok_kecamatan){
              Highcharts.chart(container, {
                  chart: {
                      borderColor: '#transparent',
                      borderWidth: 2,
                      backgroundColor: 'transparent'
                  },
                  title: {
                      text: 'Jumlah Investasi'
                  },
                  subtitle: {
                      text: 'Berdasarkan Kecamatan'
                  },
                  xAxis: {
                      type: 'category'
                  },
                  series: [{
                      type: 'pie',
                      data: kelompok_kecamatan,
                      showInLegend: false
                  }]
              });
          },
  
      getSkalaUsaha: function() {
              fetch(this.$store.state.url.URL_DASHBOARD + "viewSkala", {
                  method: "POST",
                  headers: {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                  },
                  body: JSON.stringify({
                      
                  })
              }).then(res => res.json())
                  .then(res_data => {
                  this.skala_usaha = res_data.data;
  
                  var skala_usaha = [];
                  var hasil = this.skala_usaha;
                  for(var i in hasil) {
                      skala_usaha.push([
                          hasil[i].uraian,
                          hasil[i].jml
                      ])
                  }
  
                  // console.log(res_data);
  
                  this.grafikSkala(skala_usaha);
              });
          },
  
      grafikSkala(skala_usaha){
              Highcharts.chart(containerx, {
                  chart: {
                      borderColor: '#transparent',
                      borderWidth: 2,
                      backgroundColor: 'transparent'
                  },
                  title: {
                      text: 'Skala Usaha'
                  },
                  xAxis: {
                      type: 'category'
                  },
                  series: [{
                      type: 'column',
                      data: skala_usaha,
                      showInLegend: false
                  }]
              });
          },
  
          toLocaleString: function(data){
              let text = data.toLocaleString("id-ID");
              return text
          },
      },
      mounted() {
          this.getView();
      },
  
  }
  